import React, { useContext, useMemo } from 'react'

import { ActType, getCategory, getName, getType } from '../../../../utils/entities/actType'
import { Tag } from 'antd'
import { getEmptyLabelOrValue } from '../../../../utils'
import { OrderBy } from '../../../../utils/constants'
import Cookies from 'js-cookie'
import { faEdit, faGraduationCap } from '@fortawesome/pro-solid-svg-icons'
import { getTranslate } from 'react-localize-redux'
import { connect } from 'react-redux'
import { Action, DeleteAction, ExternalAction, TableActions } from '../../../../Components/antd/Tables/DataTable/utils/actions'
import DataTable from '../../../../Components/antd/Tables/DataTable/DataTable'
import { GlobalContext } from '../../../../Providers/GlobalProvider'

const mapStateToProps = state => ({ t: getTranslate(state.locale) })

const ActTypesTable = ({ data, loading, metadata, parameters, school, user, onParametersChange, onTriggerAction, t }) => {
  const { isReadOnly } = useContext(GlobalContext)

  const maxHeight = useMemo(() => `calc(100vh - ${Cookies.get('switch_user_id') ? '230px' : '189px'})`, [Cookies.get('switch_user_id')])
  const columns = useMemo(() => [
    { title: t('acts_table.column_title.name'), orderBy: OrderBy.NAME, key: getName },
    { title: t('acts_table.column_title.category'), orderBy: OrderBy.CATEGORY, key: a => a.school ? getEmptyLabelOrValue(getCategory(a), OrderBy.CATEGORY, t) : t('act_types.label.global') },
    { title: t('acts_table.column_title.type'), orderBy: OrderBy.ACT_TYPE, key: a => <Tag color={getType(a) ? 'blue' : 'cyan'}> {t(getType(a) ? 'common.schedule' : 'Numerical')} </Tag> }
  ], [t])
  const actions = useMemo(() => isReadOnly ? [] : [
    new Action({ title: 'acts_table.actions.edit', icon: faEdit, onClick: s => onTriggerAction(s, TableActions.EDIT_ACT_TYPE), disabled: d => !d.school }),
    new Action({ title: 'acts_table.actions.display_act_type_sections', icon: faGraduationCap, onClick: s => onTriggerAction(s, TableActions.DISPLAY_ACT_TYPE_SECTIONS) }),
    new DeleteAction({ title: 'acts_table.actions.delete', onDelete: s => onTriggerAction(s, TableActions.DELETE), disabled: d => !d.school })
  ], [isReadOnly, onTriggerAction])
  const externalActions = useMemo(() => isReadOnly ? [] : [
    new ExternalAction({
      key: 'categories',
      title: t('act_types_table.external_actions.display_act_categories'),
      onClick: () => onTriggerAction(null, TableActions.DISPLAY_ACT_CATEGORIES)
    })
  ], [t, isReadOnly, onTriggerAction])

  return (
    <div style={{ height: maxHeight }}>
      <DataTable
        actions={actions}
        columns={columns}
        data={data}
        externalActions={externalActions}
        loading={loading}
        metadata={metadata}
        parameters={parameters}
        onCreate={!isReadOnly ? () => onTriggerAction(new ActType({ school }), TableActions.CREATE_ACT_TYPE) : null}
        onParametersChange={onParametersChange}
      />
    </div>
  )
}

export default connect(mapStateToProps)(ActTypesTable)
